import { Controller } from "stimulus"

export default class extends Controller {
  static values = { url: String }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const headers = { "Accept": "text/vnd.turbo-stream.html" }
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken

    fetch(this.urlValue, { method: "PATCH", headers })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}
